import * as React from 'react';

import styles from './styles.module.scss';

interface OwnProps {
	selectedCount: number;
	totalCount: number;
	onSelectAll: () => void;
	onClear: () => void;
}

type Props = OwnProps;

const SelectAll: React.FC<Props> = (props) => {
	const { selectedCount, totalCount, onSelectAll, onClear } = props;

	const allSelected = selectedCount === totalCount;
	const noneSelected = selectedCount === 0;

	const iconGlyph = React.useMemo(() => {
		if (allSelected) {
			return 'icon-checkbox_checked';
		}
		if (noneSelected) {
			return 'icon-checkbox_unchecked';
		}
		return 'icon-checkbox_disabled';
	}, [allSelected, noneSelected]);

	const handlePress = React.useCallback(() => {
		if (noneSelected) {
			onSelectAll();
		} else {
			onClear();
		}
	}, [noneSelected, onClear, onSelectAll]);

	return (
		<div className={styles.SelectAll} onClick={handlePress}>
			<span className={`${styles.icon} ${iconGlyph}`} />
		</div>
	);
};

export default React.memo(SelectAll);
